import { TrackingClient } from './TrackingClient';

export const tracking = new TrackingClient();
